import Portfolio1 from 'assets/Home/portfolio/portfolio1.avif'
import Portfolio2 from 'assets/Home/portfolio/portfolio2.avif'
import Portfolio3 from 'assets/Home/portfolio/portfolio3.avif'
import Portfolio4 from 'assets/Home/portfolio/portfolio4.avif'
import Portfolio5 from 'assets/Home/portfolio/portfolio5.avif'
import Portfolio6 from 'assets/Home/portfolio/portfolio6.avif'
import Portfolio7 from 'assets/Home/portfolio/portfolio7.avif'
import Portfolio8 from 'assets/Home/portfolio/portfolio8.avif'
import Portfolio9 from 'assets/Home/portfolio/portfolio9.avif'
// import Portfolio10 from 'assets/Home/portfolio/portfolio10.avif'
import Portfolio11 from 'assets/Home/portfolio/portfolio11.avif'
import Portfolio12 from 'assets/Home/portfolio/portfolio12.avif'

import { ReactComponent as Logo1 } from 'assets/Home/portfolio/logo1.svg'
import { ReactComponent as Logo2 } from 'assets/Home/portfolio/logo2.svg'
import { ReactComponent as Logo3 } from 'assets/Home/portfolio/logo3.svg'
import { ReactComponent as Logo4 } from 'assets/Home/portfolio/logo4.svg'
import { ReactComponent as Logo5 } from 'assets/Home/portfolio/logo5.svg'
import { ReactComponent as Logo6 } from 'assets/Home/portfolio/logo6.svg'
import { ReactComponent as Logo7 } from 'assets/Home/portfolio/logo7.svg'
import { ReactComponent as Logo8 } from 'assets/Home/portfolio/logo8.svg'
import { ReactComponent as Logo9 } from 'assets/Home/portfolio/logo9.svg'
// import { ReactComponent as Logo10 } from 'assets/Home/portfolio/logo10.svg'
import { ReactComponent as Logo11 } from 'assets/Home/portfolio/logo11.svg'
import { ReactComponent as Logo12 } from 'assets/Home/portfolio/logo12.svg'

import Detail1 from 'assets/Home/portfolio/detail1.avif'
import Detail2 from 'assets/Home/portfolio/detail2.avif'
import Detail3 from 'assets/Home/portfolio/detail3.avif'
import Detail4 from 'assets/Home/portfolio/detail4.avif'
import Detail5 from 'assets/Home/portfolio/detail5.avif'
import Detail6 from 'assets/Home/portfolio/detail6.avif'
import Detail7 from 'assets/Home/portfolio/detail7.avif'
import Detail8 from 'assets/Home/portfolio/detail8.avif'
import Detail9 from 'assets/Home/portfolio/detail9.avif'
import Detail11 from 'assets/Home/portfolio/detail11.avif'
import Detail12 from 'assets/Home/portfolio/detail12.avif'

import KeyPoint1 from 'assets/Home/portfolio/keyPoint1.avif'
import KeyPoint2 from 'assets/Home/portfolio/keyPoint2.avif'
import KeyPoint3 from 'assets/Home/portfolio/keyPoint3.avif'
import KeyPoint4 from 'assets/Home/portfolio/keyPoint4.avif'
import KeyPoint5 from 'assets/Home/portfolio/keyPoint5.avif'
import KeyPoint6 from 'assets/Home/portfolio/keyPoint6.avif'
import KeyPoint7 from 'assets/Home/portfolio/keyPoint7.avif'
import KeyPoint8 from 'assets/Home/portfolio/keyPoint8.avif'
import KeyPoint9 from 'assets/Home/portfolio/keyPoint9.avif'
import KeyPoint11 from 'assets/Home/portfolio/keyPoint11.avif'
import KeyPoint12 from 'assets/Home/portfolio/keyPoint12.avif'

import Architecture1 from 'assets/Home/portfolio/architecture1.avif'
import Architecture2 from 'assets/Home/portfolio/architecture2.avif'
import Architecture3 from 'assets/Home/portfolio/architecture3.avif'
import Architecture4 from 'assets/Home/portfolio/architecture4.avif'
import Architecture5 from 'assets/Home/portfolio/architecture5.avif'
import Architecture6 from 'assets/Home/portfolio/architecture6.avif'
import Architecture7 from 'assets/Home/portfolio/architecture7.avif'
import Architecture8 from 'assets/Home/portfolio/architecture8.avif'
import Architecture9 from 'assets/Home/portfolio/architecture9.avif'
import Architecture11 from 'assets/Home/portfolio/architecture11.avif'
import Architecture12 from 'assets/Home/portfolio/architecture12.avif'

import WireFrame1 from 'assets/Home/portfolio/wireframe1.avif'
import WireFrame3 from 'assets/Home/portfolio/wireframe3.avif'
import WireFrame4 from 'assets/Home/portfolio/dashboard1.avif'
import WireFrame5 from 'assets/Home/portfolio/wireframe5.avif'
import WireFrame6 from 'assets/Home/portfolio/wireframe6.avif'
import WireFrame7 from 'assets/Home/portfolio/wireframe7.avif'
import WireFrame11 from 'assets/Home/portfolio/wireframe11.avif'

import Arte from 'components/Portfolio/Arte'
import ColdChain from 'components/Portfolio/ColdChain'
import Fornatures from 'components/Portfolio/Fornatures'
import Sangin from 'components/Portfolio/Sangin'
import Celeb from 'components/Portfolio/Celeb'
import Showplus from 'components/Portfolio/Showplus'
import ChainEx from 'components/Portfolio/ChainEx'
import Bio from 'components/Portfolio/Bio'
import PusleOnShip from 'components/Portfolio/PusleOnShip'
import Namyoung from 'components/Portfolio/Namyoung'

export interface Data {
    data: List[]
}

export interface List {
    id: number
    logo: any,
    background: any,
    detail: any,
    name: string,
    period: string,
    description: string,
    descriptionEn: string,
    type: string,
    keyPoint: string
    keyPointImg: any,
    architecture?: any,
    wireFrame?: any,
    content?: React.ComponentType,
}

export const portfolioRaw: List[] = [
    {
        id: 12,
        logo: Logo12,
        background: Portfolio12,
        detail: Detail12,
        name: '남영테크',
        period: '2025',
        description: 'VR 안전교육 솔루션',
        descriptionEn: 'Safety Training Solution in VR 3D Field',
        type: 'VR Safety Training',
        keyPoint: `VR 안전교육 솔루션은 실제 산업 현장을 정교한 3D 가상 환경으로 완벽히 구현하여<br />
                최상의 몰입감을 제공합니다. <br /><br />

                교육생은 언리얼엔진5 기반의 가상 현장에 배치된 퀴즈를 풀며 현장에서의 위험 요소를<br />
                스스로 식별하고 대응법을 익힙니다.<br /><br />

                단순 시청을 넘어 능동적인 참여를 유도하는 퀴즈 기반 학습은 안전 의식을 내재화하고 <br />
                현장 실무 능력을 극대화하는 가장 효과적인 재해 예방책입니다.`,
        keyPointImg: KeyPoint12,
        architecture: Architecture12,
        content: Namyoung
    },
    {
        id: 11,
        logo: Logo11,
        background: Portfolio11,
        detail: Detail11,
        name: '펄스온쉽',
        period: '2025',
        description: '스마트 물류 플랫폼 SAAS',
        descriptionEn: 'Logistics Management Solution',
        type: 'Mobile Application & Web Service Platform',
        keyPoint: `PulseOnShip은 Ai와 물류 시스템이 합쳐진 복합 서비스 솔루션입니다.<br />
                사용자는 회원가입을 통해 자신의 물류 상태와 견적을 한 번에 처리 할 수 있습니다.<br /><br />

                또한, AI 챗봇 시스템과 어플리케이션 플랫폼을 두어 시간 및 장소제약없이 해당<br />
                서비스를 이용할 수 있는 점은 PulseOnShip의 기술적 잠재력을 나타냅니다.<br /><br />

                일방형 소통과 아날로그적 시스템을 넘어서 미래지향적인 자동화 및 AI 컨설턴트는<br />
                기존 물류 시스템에 새로운 활력을 불어 넣을 것입니다.`,
        keyPointImg: KeyPoint11,
        architecture: Architecture11,
        wireFrame: WireFrame11,
        content: PusleOnShip
    },
    {
        id: 1,
        logo: Logo1,
        background: Portfolio1,
        detail: Detail1,
        name: '아르떼 브이아이씨',
        period: '24.03 ~ 24.09',
        description: '전자낙관 정품인증 SNS 플랫폼',
        descriptionEn: 'EPS(Electronic Print Signature) Authenticity Verification Service',
        type: 'Mobile Application',
        keyPoint: `ESP 전자 낙관 기기와 앱을 연결하는 절차를 최소화 하여 사용자의 불편함을 최소화<br />
                SNS 기능과 채팅기능을 통해 사용자간의 다양한 정보교환 및 상호작용 서비스 제공화<br />
                디지털 상품의 출처와 진위성을 검증할 수 있는 시스템 제공화<br />
                크리에이터의 활동에 특화된 그룹메뉴 기능 제공`,
        keyPointImg: KeyPoint1,
        architecture: Architecture1,
        wireFrame: WireFrame1,
        content: Arte
    },
    {
        id: 2,
        logo: Logo2,
        background: Portfolio2,
        detail: Detail2,
        name: '메디컬 케어',
        period: '24.03 ~ 24.09',
        description: '의료 메타버스 솔루션',
        type: '3D Metaverse',
        descriptionEn: 'NFTF(Non-face-to-face) medical services in virtual space',
        keyPoint: `메타버스를 통해 환자와 의사가 3D 가상 환경에서 소통하며 대면 상담에 가까운 현실감 있는 상호작용 서비스<br />
                환자들이 장소에 구애 받지 않고 의료 상담을 받을 수 있어, 특히 원격지나 의료 접근성이 낮은 지역의 <br />
                환자들에게 편리함 제공<br /><br />
                증강현실 및 가상 진단 도구를 활용하여 원격으로도 더 정확한 건강 평가를 제공, 원격 진료의 질 향상<br />
                모든 환자 데이터와 상호작용을 의료 개인정보 보호 기준(HIPAA, GDPR 등)에 따라 보호, 가상 공간에서의<br />
                사용자 정보를 안전하게 관리`,
        keyPointImg: KeyPoint2,
        architecture: Architecture2,
    },
    {
        id: 3,
        logo: Logo3,
        background: Portfolio3,
        detail: Detail3,
        name: '콜드체인',
        period: '24.03 ~ 24.09',
        description: 'IOT 의약품 운송 솔루션',
        type: 'Mobile Application',
        descriptionEn: 'IoT Medicine System',
        keyPoint: `의약품 운송 상태와 온도, 습도와 같은 환경 조건을 실시간으로 모니터링하여 소비자가 직접 추적<br />
                IoT 기기 연동을 통해 운송 기사는 운송 중 문제나 환경 변화에 대한 즉각적인 알림을 받아 <br />
                민감한 제품안전 유지<br />
                소비자와 운송 기사 간 원활한 소통을 지원<br />
                운송 과정에서 투명성과 효율성을 높이고 신뢰 증진`,
        keyPointImg: KeyPoint3,
        architecture: Architecture3,
        wireFrame: WireFrame3,
        content: ColdChain
    },
    {
        id: 5,
        logo: Logo5,
        background: Portfolio5,
        detail: Detail5,
        name: '상인정보통',
        period: '23.01 ~',
        description: '카카오톡 상인 교육영상 플랫폼',
        type: 'Management System',
        descriptionEn: 'Merchant Training Video Management System',
        keyPoint: `효율적인 수강 지원을 위한 영상 자동재생 기능 및 검색 기능 향상, 원활한 교육 이수 실적관리 등을 위한 <br />
                관리자페이지 기능 고도화<br />
                온라인 교육을 이수한 시장(예비)매니저 대상임시 수료증(6개월 유효) 발급을 통해 개인별 수료 여부 확인 지원<br />
                전통시장 실태조사 데이터를 일정 양식에 맞춰 발주처에서 직접 최신화 및 일괄 등록할 수 있도록 기능 구현`,
        keyPointImg: KeyPoint5,
        architecture: Architecture5,
        wireFrame: WireFrame5,
        content: Sangin
    },
    {
        id: 6,
        logo: Logo6,
        background: Portfolio6,
        detail: Detail6,
        name: '셀럽하우스',
        period: '23.01 ~ 23.10',
        description: '모바일 매니지먼트 SNS 매칭 서비스',
        type: 'Mobile Application',
        descriptionEn: 'Influencer Matching SNS Service',
        keyPoint: `다양한 인플루언서와 소통을 위해 매칭 기능, 1:1 채널 운영 기능, <br />SNS 기능을 지원하여 강력한 
                커뮤니케이션 지원<br /><br />
                자신이 좋아하는 분야의 인플루언서에게 선물하고 단독으로 소통할 수 있는 포인트 서비스 제공<br />
                자체적인 광고 플랫폼으로의 기능을 제공하여 협업이 필요한 브랜드 기업 또는 대행사의 적극적인<br />
                활용 기능 제공`,
        keyPointImg: KeyPoint6,
        architecture: Architecture6,
        wireFrame: WireFrame6,
        content: Celeb
    },
    {
        id: 8,
        logo: Logo8,
        background: Portfolio8,
        detail: Detail8,
        name: '체인익스빌',
        period: '24.11',
        description: 'IOT 의약품 운송 유통 홈페이지',
        type: 'Website',
        descriptionEn: 'Phamaceutical IoT Transport Management Website',
        keyPoint: `블록체인 통합을 통해 사용자들이 의약품 정보를 실시간으로 추적하고 <br />검증할 수 있는 신뢰성 있는
                기반 컨텐츠로 구성<br />
                현대적인 색상 팔레트와 깔끔한 타이포그래피가 조화를 이루어, <br />전문적이면서도 시각적으로 편안한
                사용자 경험을 제공<br />
                의약품 관리 프로세스를 도식화하고 프로세스 및 개요를 <br />타임라인에 맞추어 사용자가 쉽게
                파악할 수 있도록 구성`,
        keyPointImg: KeyPoint8,
        architecture: Architecture8,
        content: ChainEx
    },
    {
        id: 9,
        logo: Logo9,
        background: Portfolio9,
        detail: Detail9,
        name: '제약바이오',
        period: '24.11',
        description: '제약바이오산업연구소 홈페이지',
        type: 'Website',
        descriptionEn: 'Website Related to a pharmaceutical or biotech research lab',
        keyPoint: `전문적이고 깔끔한 디자인으로 명확성과 신뢰감을 강조하는 스타일 반영<br />
                핵심 정보에 중점을 둔 쉬운 탐색을 통해 직관적인 메뉴와 명확한 정보로 구성된 섹션으로 구성<br />
                다양한 디바이스로 최적화하여 데스크톱, 태블릿, 모바일 환경에서도 일관된 경험 제공`,
        keyPointImg: KeyPoint9,
        architecture: Architecture9,
        content: Bio
    },
    {
        id: 4,
        logo: Logo4,
        background: Portfolio4,
        detail: Detail4,
        name: '포네이쳐스',
        period: '23.01 ~ 23.10',
        description: '미세조류 탄소 저감 IOT 솔루션',
        type: 'Web Admin',
        descriptionEn: 'Microalgae Carbon Reduction IoT System',
        keyPoint: `저탄소 포집 정보를 실시간으로 대시보드와 연결하여 사용자가 직관적으로 확인할 수 있도록 합니다.<br />
                공기 중 탄소 정보, 포집 정보, 효율 정보를 수집, 분석하여 위험 수치와 안전 수치를 한눈에 확인합니다.<br />
                포네이쳐스와 독립적 저탄소 기기 IoT 연결과 컨트롤러를 통해 관리 할 수 있습니다.`,
        keyPointImg: KeyPoint4,
        architecture: Architecture4,
        wireFrame: WireFrame4,
        content: Fornatures
    },
    {
        id: 7,
        logo: Logo7,
        background: Portfolio7,
        detail: Detail7,
        name: '쇼플러스',
        period: '23.01 ~ 23.10',
        description: '동영상 경연 SNS 플랫폼',
        type: 'Mobile Application',
        descriptionEn: 'SNS Short Form Contest Service',
        keyPoint: `노래, 춤, 연기 등 다양한 재능을 숏폼 영상으로 만들고 누구나 손쉽게 경연에 참여할 수 있도록 기능 제공<br />
                사용자는 포인트로 마음에 드는 공연에 투표할 수 있으며 이를 분배하는 시스템을 제공<br />
                최종 우승자에게 투표한 사람은 수익을 부배 받으며 보상을 통해 사용자 간의 응원과 커뮤니티 형성을 추진`,
        keyPointImg: KeyPoint7,
        architecture: Architecture7,
        wireFrame: WireFrame7,
        content: Showplus
    },
]

const CHUNK_SIZE = 8;

export const portfolio: Data[] = Array.from(
    { length: Math.ceil(portfolioRaw.length / CHUNK_SIZE) },
    (_, idx) => ({
        data: portfolioRaw.slice(idx * CHUNK_SIZE, (idx + 1) * CHUNK_SIZE
        ),
    })
);

export const portfolioMo: List[] = portfolioRaw